/**
 * Honesta — Theme JavaScript
 * Replaces React Context, state management, and interactive behaviors
 * with vanilla JS using Shopify AJAX Cart API
 */

(function() {
  'use strict';

  /* ==========================================================================
     1. HEADER — Sticky shadow on scroll
     ========================================================================== */
  const header = document.querySelector('[data-header]');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 20) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    });
  }

  /* ==========================================================================
     2. MOBILE MENU — Toggle slide-in menu
     ========================================================================== */
  const mobileToggle = document.querySelector('[data-mobile-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileOverlay = document.querySelector('[data-mobile-overlay]');
  const menuIcon = document.querySelector('[data-menu-icon]');
  const closeIcon = document.querySelector('[data-close-icon]');

  function toggleMobileMenu() {
    const isOpen = mobileMenu.classList.contains('is-open');
    if (isOpen) {
      mobileMenu.classList.remove('is-open');
      mobileOverlay.classList.add('hidden');
      menuIcon.classList.remove('hidden');
      closeIcon.classList.add('hidden');
    } else {
      mobileMenu.classList.add('is-open');
      mobileOverlay.classList.remove('hidden');
      menuIcon.classList.add('hidden');
      closeIcon.classList.remove('hidden');
    }
  }

  if (mobileToggle) {
    mobileToggle.addEventListener('click', toggleMobileMenu);
  }
  if (mobileOverlay) {
    mobileOverlay.addEventListener('click', toggleMobileMenu);
  }

  /* ==========================================================================
     3. CART DRAWER — Open/close, AJAX operations
     ========================================================================== */
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  const cartToggles = document.querySelectorAll('[data-cart-toggle]');
  const cartClose = document.querySelector('[data-cart-close]');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.style.right = '0';
    if (cartOverlay) cartOverlay.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.style.right = '';
    if (cartOverlay) cartOverlay.classList.add('hidden');
    document.body.style.overflow = '';
  }

  cartToggles.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      if (cartDrawer.classList.contains('is-open')) {
        closeCartDrawer();
      } else {
        openCartDrawer();
      }
    });
  });

  if (cartClose) {
    cartClose.addEventListener('click', closeCartDrawer);
  }
  if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCartDrawer);
  }

  /* --- Cart AJAX Helpers --- */
  function fetchCart() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }).then(function(r) { return r.json(); });
  }

  function updateCartUI(cart) {
    // Update count badges
    var countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach(function(el) {
      el.textContent = cart.item_count;
      if (cart.item_count > 0) {
        el.classList.remove('hidden');
      } else {
        el.classList.add('hidden');
      }
    });

    // Update drawer count
    var drawerCount = document.querySelector('[data-cart-drawer-count]');
    if (drawerCount) drawerCount.textContent = cart.item_count;

    // Update drawer total
    var drawerTotal = document.querySelector('[data-cart-drawer-total]');
    if (drawerTotal) drawerTotal.textContent = formatMoney(cart.total_price);
  }

  function formatMoney(cents) {
    return '₹' + (cents / 100).toFixed(2);
  }


function refreshCartDrawer() {
  fetch(window.location.pathname)
    .then((res) => res.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, "text/html");

      const newItems = doc.querySelector("[data-cart-drawer-items]");
      const currentItems = document.querySelector("[data-cart-drawer-items]");

      if (newItems && currentItems) {
        currentItems.innerHTML = newItems.innerHTML;
      }

      fetchCart().then(updateCartUI);
    })
}

// document.getElementById("apply-discount").addEventListener("click", (e) => {
//   e.preventDefault();

//   const code = document.getElementById("discount-code").value.trim();

//   if (!code) return;

//   window.location.href = `/discount/${encodeURIComponent(code)}?redirect=/checkout`;
// });


  /* --- AJAX Add to Cart (intercept product card forms) --- */
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form.action && form.action.indexOf('/cart/add') !== -1 && form.method.toLowerCase() === 'post') {
      // Don't intercept the main product page form if user wants standard behavior
      if (form.hasAttribute('data-product-form')) return;

      e.preventDefault();
      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(r) { return r.json();  console.log("Status:", r.status);
  console.log("Response:", data); })
      .then(function() {
        return fetchCart();
      })
      .then(function(cart) {
        updateCartUI(cart);
        openCartDrawer();
        // Reload drawer content
        // location.reload();
        refreshCartDrawer()
      })
      .catch(function(err) {
        console.error('Add to cart error:', err);
      });
    }
  });

  /* --- Cart Drawer Quantity Buttons --- */
  document.addEventListener('click', function(e) {
    var minusBtn = e.target.closest('[data-qty-minus]');
    var plusBtn = e.target.closest('[data-qty-plus]');
    var removeBtn = e.target.closest('[data-remove-item]');
    var addCoupon = e.target.closest('#apply-discount')

    if (minusBtn) {
      e.preventDefault();
      var line = parseInt(minusBtn.getAttribute('data-line'));
      var qtyEl = minusBtn.parentElement.querySelector('[data-qty-value]');
      var currentQty = parseInt(qtyEl.textContent);
      changeCartLine(line, Math.max(0, currentQty - 1));
    }

    if (plusBtn) {
      e.preventDefault();
      var line2 = parseInt(plusBtn.getAttribute('data-line'));
      var qtyEl2 = plusBtn.parentElement.querySelector('[data-qty-value]');
      var currentQty2 = parseInt(qtyEl2.textContent);
      changeCartLine(line2, currentQty2 + 1);
    }

    if (removeBtn) {
      e.preventDefault();
      var line3 = parseInt(removeBtn.getAttribute('data-line'));
      changeCartLine(line3, 0);
    }
    if(addCoupon){
      e.preventDefault();

  const code = document.getElementById("discount-code").value.trim();

  if (!code) return;

  window.location.href = `/discount/${encodeURIComponent(code)}?redirect=/checkout`;
    }
  });

  function changeCartLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartUI(cart);
       refreshCartDrawer();
      // location.reload();
    })
    .catch(function(err) {
      console.error('Cart change error:', err);
    });
  }

  /* ==========================================================================
     4. PRODUCT GALLERY — Thumbnail click → main image swap
     ========================================================================== */
  var galleryThumbs = document.querySelectorAll('[data-gallery-thumb]');
  var galleryMain = document.querySelector('[data-gallery-main]');

  galleryThumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var newSrc = this.getAttribute('data-image-url');
      if (galleryMain && newSrc) {
        galleryMain.src = newSrc;
      }

      // Update active thumbnail styling
      galleryThumbs.forEach(function(t) {
        t.classList.remove('border-green-700', 'shadow-xl');
        t.classList.add('border-gray-200');
      });
      this.classList.add('border-green-700', 'shadow-xl');
      this.classList.remove('border-gray-200');
    });
  });

  /* ==========================================================================
     5. PRODUCT TABS — Tab switching
     ========================================================================== */
  var tabButtons = document.querySelectorAll('[data-tab-button]');
  var tabContents = document.querySelectorAll('[data-tab-content]');

  tabButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var targetTab = this.getAttribute('data-tab-button');

      // Reset all tabs
      tabButtons.forEach(function(b) {
        b.classList.remove('border-green-600', 'text-green-700', 'active-tab');
        b.classList.add('border-transparent', 'text-gray-500');
      });

      tabContents.forEach(function(c) {
        c.classList.add('hidden');
      });

      // Activate clicked tab
      this.classList.add('border-green-600', 'text-green-700', 'active-tab');
      this.classList.remove('border-transparent', 'text-gray-500');

      var activeContent = document.querySelector('[data-tab-content="' + targetTab + '"]');
      if (activeContent) activeContent.classList.remove('hidden');
    });
  });

  /* ==========================================================================
     6. QUANTITY SELECTOR — Product detail page +/- buttons
     ========================================================================== */
  var qtyDecrease = document.querySelector('[data-qty-decrease]');
  var qtyIncrease = document.querySelector('[data-qty-increase]');
  var qtyInput = document.querySelector('[data-qty-input]');

  if (qtyDecrease && qtyInput) {
    qtyDecrease.addEventListener('click', function() {
      var val = parseInt(qtyInput.value);
      if (val > 1) qtyInput.value = val - 1;
    });
  }

  if (qtyIncrease && qtyInput) {
    qtyIncrease.addEventListener('click', function() {
      var val = parseInt(qtyInput.value);
      qtyInput.value = val + 1;
    });
  }

  /* ==========================================================================
     7. VARIANT SELECTOR — Update variant ID, price, and image on change
     ========================================================================== */
  var variantSelects = document.querySelectorAll('[data-variant-select]');
  var variantIdInput = document.querySelector('[data-variant-id]');
  var variantsJson = document.querySelector('[data-product-variants]');

  if (variantSelects.length > 0 && variantsJson) {
    var variants = JSON.parse(variantsJson.textContent);

    variantSelects.forEach(function(select) {
      select.addEventListener('change', function() {
        var selectedOptions = [];
        variantSelects.forEach(function(s) {
          selectedOptions.push(s.value);
        });

        // Find matching variant
        var matchedVariant = variants.find(function(v) {
          return v.options.every(function(opt, i) {
            return opt === selectedOptions[i];
          });
        });

        if (matchedVariant && variantIdInput) {
          variantIdInput.value = matchedVariant.id;

          // Update URL without reload
          var url = new URL(window.location.href);
          url.searchParams.set('variant', matchedVariant.id);
          history.replaceState({}, '', url);
        }
      });
    });
  }

  /* ==========================================================================
     8. BLOG CAROUSEL — Simple navigation (OurRead section)
     ========================================================================== */
  // The blog carousel in the Shopify version uses server-rendered content.
  // Prev/Next buttons could be wired up for client-side carousel behavior if needed.

  /* ==========================================================================
     9. INTERSECTION OBSERVER — Reveal animations (blog section)
     ========================================================================== */
  var revealItems = document.querySelectorAll('.hidden-init');
  if (revealItems.length > 0 && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;

        // Reveal all .reveal-item children with stagger
        var items = entry.target.querySelectorAll('.reveal-item');
        if (items.length > 0) {
          items.forEach(function(el, index) {
            setTimeout(function() {
              el.classList.remove('hidden-init');
              el.classList.add('revealed');
            }, index * 100);
          });
        } else {
          entry.target.classList.remove('hidden-init');
          entry.target.classList.add('revealed');
        }
      });
    }, { threshold: 0.8 });

    revealItems.forEach(function(item) {
      observer.observe(item);
    });
  }

  const gallery = document.querySelector("[data-product-gallery]");
if (!gallery) return;

const mainImage = gallery.querySelector("[data-gallery-main]");
const thumbs = [...gallery.querySelectorAll("[data-gallery-thumb]")];
const prevBtn = gallery.querySelector("[data-gallery-prev]");
const nextBtn = gallery.querySelector("[data-gallery-next]");

let currentIndex = 0;

function showImage(index) {
  // currentIndex = (index + thumbs.length) % thumbs.length;

  // const thumb = thumbs[currentIndex];

  // mainImage.src = thumb.dataset.imageUrl;

  // thumbs.forEach((t, i) => {
  //   t.classList.toggle("border-green-700", i === currentIndex);
  //   t.classList.toggle("shadow-xl", i === currentIndex);

  //   t.classList.toggle("border-gray-200", i !== currentIndex);
  // });
  currentIndex = (index + thumbs.length) % thumbs.length;

  const thumb = thumbs[currentIndex];

  mainImage.classList.add("opacity-40");

  setTimeout(() => {
    mainImage.src = thumb.dataset.imageUrl;
    mainImage.classList.remove("opacity-40");
  }, 150);
}

thumbs.forEach((thumb, index) => {
  thumb.addEventListener("click", () => showImage(index));
});

prevBtn?.addEventListener("click", () => {
  showImage(currentIndex - 1);
});

nextBtn?.addEventListener("click", () => {
  showImage(currentIndex + 1);
});

let startX = 0;

mainImage.addEventListener("touchstart", (e) => {
  startX = e.touches[0].clientX;
});

mainImage.addEventListener("touchend", (e) => {
  const endX = e.changedTouches[0].clientX;
  const diff = startX - endX;

  if (Math.abs(diff) < 50) return;

  if (diff > 0) {
    showImage(currentIndex + 1);
  } else {
    showImage(currentIndex - 1);
  }
});

})();
